import { render, staticRenderFns } from "./display-field-colorbox.vue?vue&type=template&id=3de0f43a&scoped=true&"
import script from "./display-field-colorbox.ts?vue&type=script&lang=ts&"
export * from "./display-field-colorbox.ts?vue&type=script&lang=ts&"
import style0 from "./display-field-colorbox.scss?vue&type=style&index=0&id=3de0f43a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de0f43a",
  null
  
)

export default component.exports